import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles/base.css';
import './styles/actions.css';
import './styles/chrome.css';
import './styles/session.css';
import './styles/portrait.css';
import './styles/monitor.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
